export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'cacl(100vh - 20px)',
        paddingBottom: '20px'
    },
    cardContainer: {
        padding: '20px 20px 0px 20px',
        marginLeft: '30px'
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    chatLaunchBtn: {
        height: '35px',
        width: '220px',
        borderRadius: '20px',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
        color: "#FFFFFF",
        "&.Mui-disabled": {
            backgroundColor: "#000000",
            color: "#FFFFFF",
            opacity: 0.6,
        }
    },
    launchBtnText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
        textTransform: "none",
        color: '#fffffff'
    }
});